module.exports = __webpack_public_path__ + "img/Scalable.a8763f33.png";